import { FC, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { checkPaymentStatusOffline } from 'services/package';
import PaymentSkeleton from 'components/shared/PaymentSkeleton';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { useGetPage } from 'hooks/useGetPage';
import { showPaymentLoader } from 'constants/generic';

const PackageOfflinePaymentPage: FC = () => {
  const [paymentUrl, setPaymentUrl] = useState('');
  const [triesCount, setTriesCount] = useState(60);
  const navigate = useNavigate();
  const timeout = useRef<any>();
  useGetPage('/ilpackages/book');

  useEffect(() => {
    const newData = sessionStorage.getItem('offPacPaymentOrder');
    if (newData) {
      const data = JSON.parse(newData);
      check(data.transactionId);
      setPaymentUrl(data.paymentUrl);
    }

    return () => clearTimeout(timeout.current);
  }, []); // eslint-disable-line

  const check = async (transactionId: string) => {
    setTriesCount((prev) => prev - 1);

    const responseCheck = await checkPaymentStatusOffline(transactionId);

    if (responseCheck?.bookingModel?.statusGoToXX) {
      navigate('/status-xx');
      sessionStorage.setItem(
        'bookStatusXX',
        JSON.stringify({
          orderId: responseCheck.bookingModel?.orderId,
          transactionId,
          url: 'OfflinePackages/SubmitScreenshots',
        })
      );
    } else if (responseCheck?.orderHasBeenPaid) {
      sessionStorage.setItem(
        'offPacSuccessOrder',
        JSON.stringify({ ...responseCheck.bookingModel, transactionId })
      );
      navigate(`/offline-package/success`);
    } else if (responseCheck?.hasErrors) {
      sessionStorage.setItem('errMessage', responseCheck?.errorMessage);
      sessionStorage.setItem(
        'bookFail',
        JSON.stringify({
          orderId: responseCheck.bookingModel?.orderId,
          transactionId,
          url: 'OfflinePackages/SubmitScreenshots',
        })
      );
      navigate('/fail');
    } else if (triesCount > 0) {
      timeout.current = setTimeout(() => check(transactionId), 5000);
    }
  };

  return (
    <div
      className="details-wrapper position-relative"
      style={{ justifyContent: 'center', height: 830 }}
    >
      
        <PaymentSkeleton systemProducts="Nofshon" showPaymentLoader={showPaymentLoader} />

      {paymentUrl && !paymentUrl.includes('<iframe') && (
        <iframe
          src={paymentUrl}
          title="pay"
          width={470}
          height={577}
          style={{ marginTop: 35, zIndex: 1 }}
        />
      )}

      {paymentUrl && paymentUrl.includes('<iframe') && (
        <div className="book-payment-wr" dangerouslySetInnerHTML={{ __html: paymentUrl }}></div>
      )}
    </div>
  );
};

export default withErrorBoundary(PackageOfflinePaymentPage, 'PackageOfflinePaymentPage');
